import type { RouteLocationGeneric } from 'vue-router';

import { createModuleBuilder } from '@evidentid/dashboard-commons/app';
import { GatewayApiClient } from '@evidentid/gateway-api-client';

import GoAppSettings from '@/modules/go-app-settings/views/GoAppSettings.vue';

export const goAppSettingsModule = createModuleBuilder()
    .registerRoutes(() => [
        {
            path: '/:rpId?/configuration/go-app',
            name: 'goAppSettings',
            component: GoAppSettings as any,
            meta: { title: 'Go App', pageClass: 'GoAppSettings' },
        },
        {
            // Legacy `/configuration/counter` URL, kept as a redirect because it is still in bookmarks
            // and in support replies.
            // TODO(PRODUCT-26795): drop once that URL has fallen out of use.
            path: '/:rpId?/configuration/counter',
            redirect: (to: RouteLocationGeneric) => ({
                name: 'goAppSettings',
                params: to.params,
            }),
        },
    ])
    .demandContext<{ gatewayClient: GatewayApiClient }>()
    .end();
